// Inventory Products Vuex

import state from './productionStates.js'
import * as getters from './productionGetters.js'
import * as mutations from './productionMutations.js'
import * as actions from './productionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
